module.exports = __webpack_public_path__ + "static/media/upload-icon.1fe9d019.svg";